export const apiUri = process.env.REACT_APP_API;